import { render, staticRenderFns } from "./AdminConsole.vue?vue&type=template&id=50d13b24&scoped=true&"
import script from "./AdminConsole.vue?vue&type=script&lang=js&"
export * from "./AdminConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d13b24",
  null
  
)

export default component.exports